import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * EndSimulationButtons:
 *  - Renders the NotebookContent Section EndSimulationButtons
 */
export function EndSimulationButtons(props) {
  const className = `${style.btns} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

EndSimulationButtons.propTypes = {
  /**
   * List of buttons to display on EndSimulationBanner
   */
  children: PropTypes.object,
  /**
   * ClassName
   */
  className: PropTypes.string,
};

EndSimulationButtons.defaultProps = {
  className: "",
};
